export interface NotificationLike {
  title?: string;
  body?: string;
  data?: Record<string, any> | null;
}

export function getNotificationDedupKey(notif: NotificationLike): string {
  const title = String(notif?.title ?? '').trim().toLowerCase();
  const body = String(notif?.body ?? '').trim().toLowerCase();
  const data = notif?.data ? JSON.stringify(sortData(notif.data)) : '';
  return `${title}::${body}::${data}`;
}

export function dedupeNotifications<T extends NotificationLike>(items: T[]): T[] {
  const seen = new Set<string>();
  return items.filter((item) => {
    const key = getNotificationDedupKey(item);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

function sortData(value: Record<string, any>): Record<string, any> {
  if (Array.isArray(value)) {
    return value.map(sortData) as any;
  }
  if (value && typeof value === 'object') {
    return Object.keys(value).sort().reduce<Record<string, any>>((acc, key) => {
      acc[key] = sortData(value[key]);
      return acc;
    }, {});
  }
  return value;
}
